<template>
  <div class="c-teikibin-popup">
    <transition name="fade">
      <div class="c-teikibin-popup__background" v-show="isShow">
        <div class="c-teikibin-popup__container">
          <button
            class="c-teikibin-popup__button-close"
            @click="$emit('close-clicked')"
            aria-label="閉じる"
          ></button>
          <slot />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'ComponentsTeikibinPopup',
  props: {
    isShow: { type: Boolean, default: false },
  },
}
</script>

<style lang="scss" scoped>
@use '~/scss/generic/mixins';
@use '~/scss/modules/teikibin';

.c-teikibin-popup {
  &__background {
    background-color: rgba(#000, 0.6);
    bottom: 0;
    display: flex;
    left: 0;
    padding: 20px;
    position: fixed;
    top: 0;
    right: 0;
    z-index: teikibin.$z-index-popup;

    &.fade-enter-active,
    &.fade-leave-active {
      transition: opacity 0.3s ease;
    }

    &.fade-enter-from,
    &.fade-leave-to {
      opacity: 0;
    }
  }

  &__container {
    background-color: #fff;
    margin: auto;
    max-width: teikibin.$width-content - 40px;
    max-height: 100%;
    overflow-y: scroll;
    padding: 50px 30px 30px;
    position: relative;
    scrollbar-width: none;
  }

  &__button-close {
    width: 35px;
    height: 35px;
    position: absolute;
    top: 10px;
    right: 10px;

    &::before,
    &::after {
      background-color: teikibin.$color-text;
      content: '';
      height: 25px;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 1px;
      margin: auto;
    }

    &::before {
      transform: rotate(45deg);
    }
    &::after {
      transform: rotate(-45deg);
    }
  }
}
</style>
